function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/partyA/partyAHome/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'home')
    }
}

let routes = [
    {
        name: 'partyAHome',
        path: '/partyA/partyAHome',
        meta: {
            title: '领筑云'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/partyA/home.js